import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "split-modal-header" }
const _hoisted_2 = { class: "header-title" }
const _hoisted_3 = { class: "original-info" }
const _hoisted_4 = { class: "info-row" }
const _hoisted_5 = { class: "info-value" }
const _hoisted_6 = { class: "info-row" }
const _hoisted_7 = { class: "info-row" }
const _hoisted_8 = { class: "info-value amount" }
const _hoisted_9 = { class: "info-row full" }
const _hoisted_10 = { class: "info-value memo" }
const _hoisted_11 = { class: "split-guide" }
const _hoisted_12 = { class: "split-items-container" }
const _hoisted_13 = { class: "split-items-header" }
const _hoisted_14 = { class: "split-items-list" }
const _hoisted_15 = { class: "item-num" }
const _hoisted_16 = { class: "item-fields" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "field-price" }
const _hoisted_20 = ["value", "onInput"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["onClick", "disabled"]
const _hoisted_23 = { class: "split-summary" }
const _hoisted_24 = { class: "summary-row" }
const _hoisted_25 = { class: "summary-row" }
const _hoisted_26 = { class: "summary-value original" }
const _hoisted_27 = { class: "summary-value" }
const _hoisted_28 = { class: "split-modal-actions" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]

import { ref, computed, watch, onMounted } from 'vue';
import { bankbookApi } from '@/services/api';

interface SplitItem {
  scode: string | null;
  price: number;
  memo: string;
  bankCode: string | null;
  sortOrder: number;
}

interface AccountCode {
  scode: string;
  sname: string;
  gubun: 'IN' | 'OUT';
  displayName: string;
}

interface BankItem {
  mb_code: string;
  mb_alias: string;
  mb_bank_name: string;
}

interface ParentItem {
  cb_idx: number;
  m_code: number;
  cb_biz_gubun: string | null;
  cb_gubun: 'IN' | 'OUT';
  cb_date: string;
  cb_price: number;
  cb_memo: string | null;
  cb_scode: string | null;
  cb_bank_code: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SplitModal',
  props: {
    modelValue: { type: Boolean },
    cbIdx: {},
    year: {},
    accountCodes: {},
    bankList: {}
  },
  emits: ["update:modelValue", "saved"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const parentItem = ref<ParentItem | null>(null);
const splitItems = ref<SplitItem[]>([]);
const hasSplits = ref(false);
const isSaving = ref(false);
const isMerging = ref(false);

const accountCodeList = computed(() => {
  if (!parentItem.value) return [];
  // 원본의 cb_gubun(IN/OUT)과 일치하는 계정만 표시
  const gubun = parentItem.value.cb_gubun;
  return props.accountCodes.filter(code => code.gubun === gubun);
});

/** 계정명·코드 모두 검색 */
const accountFilter = (
  _value: string,
  query: string,
  item?: { raw?: AccountCode }
) => {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return true;
  const raw = item?.raw;
  const sname = String(raw?.sname || _value || '').toLowerCase();
  const scode = String(raw?.scode || '').toLowerCase();
  return sname.includes(q) || scode.includes(q);
};

const bankList = computed(() => props.bankList || []);

const parentPrice = computed(() => {
  return Number(parentItem.value?.cb_price) || 0;
});

const splitTotal = computed(() => {
  return splitItems.value.reduce((sum, item) => sum + (Number(item.price) || 0), 0);
});

const difference = computed(() => {
  return splitTotal.value - parentPrice.value;
});

const isSumValid = computed(() => {
  return splitTotal.value === parentPrice.value;
});

const isAllFieldsValid = computed(() => {
  return splitItems.value.every(item => 
    item.scode && item.scode.trim() !== '' && 
    item.bankCode && item.bankCode.trim() !== '' &&
    Number(item.price) > 0
  );
});

const formatDate = (date: string | null | undefined) => {
  if (!date) return '-';
  return date.substring(0, 10);
};

const formatNumber = (num: number | string | null | undefined) => {
  if (num === null || num === undefined) return '0';
  const n = Number(num);
  if (isNaN(n)) return '0';
  return n.toLocaleString();
};

const handlePriceInput = (event: Event, index: number) => {
  const input = event.target as HTMLInputElement;
  const value = input.value.replace(/[^0-9]/g, '');
  splitItems.value[index].price = parseInt(value) || 0;
};

const addSplitItem = () => {
  splitItems.value.push({
    scode: null,
    price: 0,
    memo: '',
    bankCode: parentItem.value?.cb_bank_code || '',
    sortOrder: splitItems.value.length
  });
};

const removeSplitItem = (index: number) => {
  if (splitItems.value.length > 2) {
    splitItems.value.splice(index, 1);
    splitItems.value.forEach((item, idx) => {
      item.sortOrder = idx;
    });
  }
};

const loadSplits = async () => {
  if (!props.cbIdx) return;

  try {
    const response = await bankbookApi.getSplits(props.cbIdx, props.year);
    
    if (response.data.success) {
      const data = response.data.data;
      parentItem.value = data.parent;
      
      // 새로운 구조: 분개 항목이 있으면 hasSplits = true
      const splits = data.splits || [];
      hasSplits.value = splits.length > 0;

      if (splits.length > 0) {
        splitItems.value = splits.map((s: any, idx: number) => ({
          scode: s.cbs_scode,
          price: Number(s.cbs_price) || 0,
          memo: s.cbs_memo || '',
          bankCode: s.cbs_bank_code || '',
          sortOrder: idx
        }));
      } else {
        initEmptySplits();
      }
    }
  } catch (error: any) {
    console.error('분개 조회 오류:', error);
    alert('분개 정보를 불러오는데 실패했습니다.');
  }
};

const initEmptySplits = () => {
  const originalPrice = Number(parentItem.value?.cb_price) || 0;
  const halfPrice = Math.floor(originalPrice / 2);
  const defaultBankCode = parentItem.value?.cb_bank_code || '';
  
  splitItems.value = [
    {
      scode: null,
      price: halfPrice,
      memo: '',
      bankCode: defaultBankCode,
      sortOrder: 0
    },
    {
      scode: null,
      price: originalPrice - halfPrice,
      memo: '',
      bankCode: defaultBankCode,
      sortOrder: 1
    }
  ];
};

const saveSplits = async () => {
  if (!props.cbIdx || !isSumValid.value || !isAllFieldsValid.value) return;

  isSaving.value = true;
  try {
    const lines = splitItems.value.map(item => ({
      scode: item.scode || undefined,
      price: Number(item.price) || 0,
      memo: item.memo || undefined,
      bankCode: item.bankCode || undefined,
      sortOrder: item.sortOrder
    }));

    const response = await bankbookApi.saveSplits(props.cbIdx, lines);

    if (response.data.success) {
      alert(response.data.message || '분개가 저장되었습니다.');
      emit('saved');
      closeDialog();
    } else {
      alert(response.data.message || '분개 저장에 실패했습니다.');
    }
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`분개 저장 실패: ${message}`);
    console.error('분개 저장 오류:', error);
  } finally {
    isSaving.value = false;
  }
};

const mergeSplits = async () => {
  if (!props.cbIdx || !hasSplits.value || isMerging.value) return;
  if (!confirm('분개된 항목을 합쳐 원본 한 건으로 되돌릴까요?')) return;

  isMerging.value = true;
  try {
    const response = await bankbookApi.clearSplits(props.cbIdx);
    if (response.data.success) {
      alert(response.data.message || '분개를 합쳤습니다.');
      emit('saved');
      closeDialog();
    } else {
      alert(response.data.message || '분개 합치기에 실패했습니다.');
    }
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`분개 합치기 실패: ${message}`);
    console.error('분개 합치기 오류:', error);
  } finally {
    isMerging.value = false;
  }
};

const closeDialog = () => {
  dialogVisible.value = false;
};

watch(() => props.modelValue, (newVal) => {
  if (newVal && props.cbIdx) {
    loadSplits();
  }
});

watch(() => props.cbIdx, (newVal) => {
  if (newVal && props.modelValue) {
    loadSplits();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
    "max-width": "900",
    persistent: "",
    class: "split-modal-dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "split-modal-card" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                size: "22",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-call-split", -1)
                ]))]),
                _: 1
              }),
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "통장내역 분개", -1))
            ]),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: closeDialog
            }, [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "info-label" }, "거래일", -1)),
              _createElementVNode("span", _hoisted_5, _toDisplayString(formatDate(parentItem.value?.cb_date)), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "info-label" }, "구분", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["info-value", parentItem.value?.cb_gubun === 'IN' ? 'income' : 'expense'])
              }, _toDisplayString(parentItem.value?.cb_gubun === 'IN' ? '수입' : '지출'), 3)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "info-label" }, "금액", -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(formatNumber(parentItem.value?.cb_price)) + "원", 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "info-label" }, "적요", -1)),
              _createElementVNode("span", _hoisted_10, _toDisplayString(parentItem.value?.cb_memo || '-'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_icon, {
              size: "16",
              color: "#6366f1"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("mdi-information-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "원본 금액을 여러 계정으로 나누어 설정할 수 있습니다. 분개 합계는 원본 금액과 일치해야 합니다.", -1))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "header-label" }, "분개 항목", -1)),
              _createElementVNode("button", {
                class: "add-item-btn",
                onClick: addSplitItem
              }, [
                _createVNode(_component_v_icon, { size: "16" }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("mdi-plus", -1)
                  ]))]),
                  _: 1
                }),
                _cache[11] || (_cache[11] = _createTextVNode(" 항목 추가 ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(splitItems.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "split-item"
                }, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(index + 1), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_v_autocomplete, {
                      modelValue: item.scode,
                      "onUpdate:modelValue": ($event: any) => ((item.scode) = $event),
                      items: accountCodeList.value,
                      "item-title": "sname",
                      "item-value": "scode",
                      "custom-filter": accountFilter,
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: "",
                      "auto-select-first": "",
                      placeholder: "계정 검색",
                      "no-data-text": "검색 결과 없음",
                      class: "field-autocomplete scode"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((item.bankCode) = $event),
                      class: "field-select bank"
                    }, [
                      _cache[13] || (_cache[13] = _createElementVNode("option", {
                        value: "",
                        disabled: ""
                      }, "통장 선택", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bankList.value, (bank) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: bank.mb_code,
                          value: bank.mb_code
                        }, _toDisplayString(bank.mb_alias || bank.mb_bank_name), 9, _hoisted_18))
                      }), 128))
                    ], 8, _hoisted_17), [
                      [_vModelSelect, item.bankCode]
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("input", {
                        type: "text",
                        value: formatNumber(item.price),
                        onInput: ($event: any) => (handlePriceInput($event, index)),
                        placeholder: "0"
                      }, null, 40, _hoisted_20),
                      _cache[14] || (_cache[14] = _createElementVNode("span", null, "원", -1))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((item.memo) = $event),
                      placeholder: "적요",
                      class: "field-memo"
                    }, null, 8, _hoisted_21), [
                      [_vModelText, item.memo]
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "item-delete",
                    onClick: ($event: any) => (removeSplitItem(index)),
                    disabled: splitItems.value.length <= 2
                  }, [
                    _createVNode(_component_v_icon, { size: "14" }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_22)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "summary-label" }, "분개 합계", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["summary-value", { error: !isSumValid.value }])
                }, _toDisplayString(formatNumber(splitTotal.value)) + "원 ", 3)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "summary-label" }, "원본 금액", -1)),
                _createElementVNode("span", _hoisted_26, _toDisplayString(formatNumber(parentPrice.value)) + "원", 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["summary-row difference", { valid: isSumValid.value, invalid: !isSumValid.value }])
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "summary-label" }, "차이", -1)),
                _createElementVNode("span", _hoisted_27, _toDisplayString(isSumValid.value ? '일치' : `${formatNumber(Math.abs(difference.value))}원 ${difference.value > 0 ? '초과' : '부족'}`), 1)
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            (hasSplits.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn-merge",
                  type: "button",
                  disabled: isSaving.value || isMerging.value,
                  onClick: mergeSplits
                }, [
                  (isMerging.value)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        indeterminate: "",
                        size: "16",
                        width: "2",
                        color: "#b91c1c"
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        size: "16"
                      }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode("mdi-call-merge", -1)
                        ]))]),
                        _: 1
                      })),
                  _cache[20] || (_cache[20] = _createTextVNode(" 분개 합치기 ", -1))
                ], 8, _hoisted_29))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn-cancel",
              type: "button",
              disabled: isSaving.value || isMerging.value,
              onClick: closeDialog
            }, " 취소 ", 8, _hoisted_30),
            _createElementVNode("button", {
              class: "btn-save",
              type: "button",
              onClick: saveSplits,
              disabled: !isSumValid.value || !isAllFieldsValid.value || isSaving.value || isMerging.value
            }, [
              (isSaving.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "16",
                    width: "2",
                    color: "white"
                  }))
                : (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    size: "16"
                  }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createTextVNode("mdi-content-save", -1)
                    ]))]),
                    _: 1
                  })),
              _createTextVNode(" " + _toDisplayString(hasSplits.value ? '수정' : '저장'), 1)
            ], 8, _hoisted_31)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})